module.exports = __webpack_public_path__ + "img/messenger-preview-header.d9de37b.png";